export type DecodeExceptionType =
  | 'INVALID_URL'
  | 'ACCESS_DENIED'
  | 'GENERIC_ERROR'
  | 'MISSING_STATE_OR_CODE'
  | 'DECODE_ERROR';

export class DecodeProviderCallbackException {
  constructor(public type: DecodeExceptionType) {}
}
